import { render } from "./view_case_details.html?vue&type=template&id=0b01d12e&external"
import script from "./view_case_details.js?vue&type=script&lang=js&external"
export * from "./view_case_details.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__